<template>
  <main class="auth-page">
    <section class="signin-card" aria-labelledby="signin-title">
      <img class="signin-logo" src="/iosea-logo-cropped.png" alt="IOSEA">
      <h1 id="signin-title">Sign in</h1>
      <p class="signin-description">Access the IOSEA developer portal.</p>
      <LoginForm @login="enterHomePage" />
    </section>
  </main>
  <footer class="app-footer auth-footer">
    <div>Copyright &copy; 2026 IOSEA Inc. All rights reserved.</div>
    <div class="footer-version">Documentation version {{ documentationVersion }}</div>
  </footer>
</template>

<script>
import { useRoute, useRouter } from 'vue-router';
import LoginForm from '../components/LoginForm.vue';
import { DOCUMENTATION_VERSION } from '../config/app';
import { projectAuth } from '../firebase/config';

export default {
  name: 'SignIn',
  components: { LoginForm },
  setup() {
    const route = useRoute();
    const router = useRouter();
    const documentationVersion = DOCUMENTATION_VERSION;

    const enterHomePage = async () => {
      const user = projectAuth.currentUser;
      let displayDockerCompose = false;
      try {
        const { getUserDocument } = await import('../firebase/firestore');
        const snapshot = await getUserDocument(user.uid);
        if (snapshot.exists()) displayDockerCompose = snapshot.data().display_docker_compose || false;
      } catch (error) {
        displayDockerCompose = false;
      }
      window.localStorage.setItem('displayDockerCompose', displayDockerCompose);
      router.push({ name: 'Home', query: route.query });
    };

    return { documentationVersion, enterHomePage };
  }
};
</script>
